import React from 'react';
import { FormContainer as FormContainerType, FormElement } from '../../schema/form.schema';
import styles from '../../assets/css/container.module.css';
import FormElementComponent from './FormElement';
import { Data, useFormData } from '../../hooks/useFormData';
import { useFormValidation } from '../../hooks/useFormValidation';

interface FormContainerProps {
	form: FormContainerType;
	onChange: (data: Data) => void;
	onValidationChange: (isValid: boolean) => void;
}

const Form: React.FC<FormContainerProps> = ({ form, onChange, onValidationChange }) => {
	const { onDataChange } = useFormData(form, onChange);
	const { onValidationResultChange } = useFormValidation(form, onValidationChange);

	return (
		<div style={{ width: '100%' }}>
			<div className={styles['form-container']}>
				{form.elements.map((element: FormElement, index: number) => (
					<FormElementComponent
						key={index}
						element={element}
						onChange={onDataChange}
						onValidationChange={onValidationResultChange}
					/>
				))}
			</div>
		</div>
	);
};

export default Form;
